import { biOpenWidget } from '../../bi';
import { dispatch, getState } from '../../store';

export const expandWidget = (): void => {
  const {
    chatbot: { dealerOffer },
    tooltip,
  } = getState();
  dispatch('widget/expanded', true);
  dispatch('chatbot/unreadCount', 0);
  biOpenWidget();
  if (dealerOffer && tooltip.isOpened) {
    dispatch('tooltip/close-per-offer', dealerOffer);
  }
};
